import { GoogleGenAI } from "@google/genai";

// Configuration with Fallback
// This ensures the AI features work even if .env injection fails
const getApiKey = (): string => {
  const fallback = "AIzaSyBqqanV3tbqh3mKPuUnxq0Sqpl05EsEZDw";
  try {
    // @ts-ignore
    if (import.meta && import.meta.env && import.meta.env.VITE_GEMINI_API_KEY) {
      // @ts-ignore
      return import.meta.env.VITE_GEMINI_API_KEY;
    }
  } catch (e) {
    // ignore
  }
  return fallback;
};

const apiKey = getApiKey();

export const refineText = async (text: string): Promise<string | null> => {
  if (!apiKey) {
    console.warn("Gemini API Key is missing.");
    return null;
  }

  try {
    // Initialize client only when needed
    const ai = new GoogleGenAI({ apiKey });
    
    const response = await ai.models.generateContent({
      model: 'gemini-3-flash-preview',
      contents: `You are an expert editor. Rewrite the following text to be more clear, objective, and concise. 
      Maintain the original meaning but improve flow, grammar, and professional tone. 
      Return ONLY the rewritten text, without any conversational filler or markdown code blocks.
      
      Text to rewrite:
      ${text}`,
    });

    return response.text?.trim() || null;
  } catch (error) {
    console.error("Error refining text with AI:", error);
    return null;
  }
};